"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = LoanAmount;
var _react = _interopRequireWildcard(require("react"));
var _Row = _interopRequireDefault(require("react-bootstrap/Row"));
var _Col = _interopRequireDefault(require("react-bootstrap/Col"));
var _Form = _interopRequireDefault(require("react-bootstrap/Form"));
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
var _reactRedux = require("react-redux");
var _actions = require("../store/actions");
var _usersession = require("usersession");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function LoanAmount() {
  const userSession = new _usersession.UserSession();
  const [estimatedValue, setEstimatedValue] = (0, _react.useState)("");
  const [loanBalance, setLoanBalance] = (0, _react.useState)("");
  const [cashout, setCashout] = (0, _react.useState)("");
  const dispatch = (0, _reactRedux.useDispatch)();
  const evalue = (0, _reactRedux.useSelector)(state => state.nameReducer.estimatedHomeValue);
  const lbalance = (0, _reactRedux.useSelector)(state => state.nameReducer.loanAmount);
  const cashoutAmount = (0, _reactRedux.useSelector)(state => state.nameReducer.cashoutAmount);
  // const evalue = state.estimatedHomeValue;
  // const lbalance = state.loanAmount;
  // const cashoutAmount = state.cashoutAmount;

  (0, _react.useEffect)(() => {
    dispatch((0, _actions.ShowButtons)(false));
    // ShowButtons(false);
    document.getElementById("next-button").disabled = false;
    setEstimatedValue(evalue);
    setLoanBalance(lbalance);
    setCashout(cashoutAmount);
    userSession.setEstimatedValue(evalue);
    userSession.setCurrentLoanBalance(lbalance);
    userSession.setCashOutAmount(cashoutAmount);
    if (estimatedValue && loanBalance && cashout) dispatch((0, _actions.ShowButtons)(true));
    // ShowButtons(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [estimatedValue, loanBalance, cashout]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Row.default, {
    className: "d-flex justify-content-center text-left pt-1 adjust_mobile_width"
  }, /*#__PURE__*/_react.default.createElement(_Form.default.Group, {
    as: _Col.default,
    lg: 8
  }, /*#__PURE__*/_react.default.createElement("h4", {
    className: "p-0"
  }, "Current loan balance (How much do you currently owe)?"), /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    className: "form-control",
    placeholder: "Current Loan Balance",
    value: loanBalance,
    displayType: 'input',
    thousandSeparator: true,
    prefix: '$',
    decimalScale: 2,
    fixedDecimalScale: true,
    onValueChange: values => {
      setLoanBalance(values.value);
      dispatch((0, _actions.loanAmountTotalUpdate)(values.value));
      // loanAmountTotalUpdate(values.value);
    }
  })), /*#__PURE__*/_react.default.createElement(_Form.default.Group, {
    as: _Col.default,
    lg: 8
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Cash out amount"), /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    className: "form-control",
    placeholder: "Cash-Out Amount",
    value: cashout,
    displayType: 'input',
    thousandSeparator: true,
    prefix: '$',
    decimalScale: 2,
    fixedDecimalScale: true,
    onValueChange: values => {
      setCashout(values.value);
      dispatch((0, _actions.cashoutAmountUpdate)(values.value));
      // cashoutAmountUpdate(values.value);
    }
  })), /*#__PURE__*/_react.default.createElement(_Form.default.Group, {
    as: _Col.default,
    lg: 8
  }, /*#__PURE__*/_react.default.createElement("h4", null, "Estimated home value"), /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, {
    className: "form-control",
    placeholder: "Estimated Home Value",
    value: estimatedValue,
    displayType: 'input',
    thousandSeparator: true,
    prefix: '$',
    decimalScale: 0,
    fixedDecimalScale: false,
    onValueChange: values => {
      setEstimatedValue(values.value);
      dispatch((0, _actions.estimatedHomeValueUpdate)(values.value));
      // estimatedHomeValueUpdate(values.value);
    }
  }))));
}